module.exports = __webpack_public_path__ + "static/media/5DPO6.057e1811.jpg";